import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { AboutRescue } from "./components/AboutRescue";
import { ProjectSection, SectionDivider } from "./components/ProjectSection";
import { Contact } from "./components/Contact";

const IMG_BRAZIL =
  "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/r49a4t15_IMG_9947.jpeg";
const BRAZIL_GALLERY = [
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/wj4e3zwz_a78db6a5-11d7-4542-b04a-cd58347e6d5a.JPG",
    alt: "RoboCup Brazil — BSM team & robot",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/11rcuxfm_0825a575-24c5-4096-b472-c0f64ca312f5.MP4",
    alt: "RoboCup Brazil — match footage",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/asknjktx_IMG_9878.MOV",
    alt: "RoboCup Brazil — competition clip 2",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/wv5bq2hk_new%20short%202.mov",
    alt: "RoboCup Brazil — competition short",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/z6ykpgyr_553400ad-5c04-42fe-a31a-3763c7ea25f0.MOV",
    alt: "RoboCup Brazil — competition clip",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/wjryegcd_7960179600192226679.MOV",
    alt: "RoboCup Brazil — field run",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/4k40blz2_21176fb7-bf37-4478-9a15-7408f46e7dce.JPG",
    alt: "RoboCup Brazil — gravel rubble course",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/lubsr24g_0605e164-7f28-468d-8162-a5a0919fd462.JPG",
    alt: "RoboCup Brazil — stepfield obstacle course",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/kucvf05p_6f0b1096-a073-4086-ab31-2622bd884548.JPG",
    alt: "RoboCup Brazil — rolling platform obstacle",
  },
];

const IMG_KOREA =
  "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/63182jc4_2CA8C253-1A9A-43C9-914E-B71FF13465C4.JPG";
const KOREA_GALLERY = [
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/zocieqv5_IMG_1909.webp",
    alt: "RoboCup Korea — BSM Robotics team with the robot",
  },
  {
    type: "image",
    url: "/korea-robot-1746.webp",
    alt: "RoboCup Korea — rescue robot with arm and flippers",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/0iuhqnv5_1_D0uuw3nS.mp4",
    alt: "RoboCup Korea — video 1",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/6gg0og70_2..mp4",
    alt: "RoboCup Korea — video 2",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/mwq69zrb_3_N0IYrcGO.mp4",
    alt: "RoboCup Korea — video 3",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/u566nx73_4_YUVvPlIX.mp4",
    alt: "RoboCup Korea — video 4",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/hvjvjkiq_5_On0KUrSz.mp4",
    alt: "RoboCup Korea — video 5",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/dqtwd6rn_6_S7HyH4ys.mp4",
    alt: "RoboCup Korea — video 6",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/9n1c3kuy_7test22_qnllkghn.mp4",
    alt: "RoboCup Korea — video 7",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/f69hjyc2_8_j2n8Ud0j.mp4",
    alt: "RoboCup Korea — video 8",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/97dvytcx_9_6cXRh2SO.mp4",
    alt: "RoboCup Korea — video 9",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/w7mfl3dk_10_1LhnaTzT.mp4",
    alt: "RoboCup Korea — video 10",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/wi9yh95g_11trim_hjsw1DpO.mp4",
    alt: "RoboCup Korea — video 11",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/dvgc8ihw_12_DEqAZUhc.mp4",
    alt: "RoboCup Korea — video 12",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/h7yvx152_13_Au57taxR.mp4",
    alt: "RoboCup Korea — video 13",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/metwdmq0_IMG_0754.jpeg",
    alt: "RoboCup Korea — drivetrain top-down",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/ik5s2pi9_IMG_0843.jpg",
    alt: "RoboCup Korea — robot with arm extended",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/i8m62gy9_IMG_0845%20%281%29.jpg",
    alt: "RoboCup Korea — robot in workshop",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/ov7f14rb_IMG_5403%20%281%29.jpeg",
    alt: "RoboCup Korea — workshop detail",
  },
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/vcwh7hdn_IMG_1273.jpg",
    alt: "RoboCup Korea — robot detail shot",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/gi7phep4_IMG_0827.MOV",
    alt: "RoboCup Korea — build clip 1",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/d3jcoi2n_IMG_0829.MOV",
    alt: "RoboCup Korea — build clip 2",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/5ohxnhpc_IMG_0830.MOV",
    alt: "RoboCup Korea — build clip 3",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/a88sc26d_IMG_0831.MOV",
    alt: "RoboCup Korea — build clip 4",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/sv5gr5ub_IMG_0833.MOV",
    alt: "RoboCup Korea — build clip 5",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/209ca56b_IMG_0894.MOV",
    alt: "RoboCup Korea — build clip 6",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/22ahda16_IMG_0897.mov",
    alt: "RoboCup Korea — build clip 7",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/6ppqvve5_IMG_1059.MOV",
    alt: "RoboCup Korea — build clip 8",
  },
  {
    type: "video",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/vg8pizzw_new%20long%20vid.mov",
    alt: "RoboCup Korea — extended walkthrough",
  },
];

const IMG_LONGBOARD =
  "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/ugu8u8dp_29B07460-F889-42DA-B055-D7235264985B.PNG";
const LONGBOARD_GALLERY = [
  {
    type: "image",
    url: "https://customer-assets.emergentagent.com/job_robocup-showcase/artifacts/zti3zcxd_ChatGPT%20Image%20Jun%204%2C%202026%2C%2007_57_20%20PM.png",
    alt: "Electric Longboard — system architecture diagram",
  },
];

const Home = () => {
  return (
    <div className="grain min-h-screen bg-[#050505] text-white selection:bg-[#FF3B30]">
      <Navbar />

      <main>
        <Hero />

        <AboutRescue />

        <SectionDivider text="Brazil 2024-25 / First International Run" />

        <ProjectSection
          id="robocup-brazil"
          index="01"
          eyebrow="// BSM Robotics · Mechanical Specialist"
          title="RoboCup Brazil"
          timeframe="2024 — 2025"
          location="Brazil · International"
          role="Mechanical Lead — BSM Robotics"
          description="My first major international appearance — and we were the only high school team on the floor competing against colleges. We arrived having gone through multiple full chassis revisions throughout the year, each one a deliberate choice to iterate fast, fail early, and build something better. That process paid off. We advanced further into the competition than the team ever had, pushing within reach of the semifinals before a catastrophic electrical failure ended our run."
          highlights={[
            "Drove mechanical design end-to-end, from CAD through fabrication using the CNC router and 3D printers.",
            "Engineered the main chassis and articulated flipper system, enabling the robot to traverse uneven terrain.",
            "Completely redesigned the electrical enclosure for improved modularity — the box now attaches and detaches cleanly from the chassis, making field repairs significantly faster.",
            "Drove gear ratio selection and motor configuration decisions for the drivetrain.",
            "Managed task delegation across a ~14-person school-year team narrowed down to an 8-person competition squad.",
          ]}
          specs={[
            { label: "Stage", value: "International" },
            { label: "Team Size", value: "8 / ~14" },
            { label: "Focus", value: "Chassis · Flippers" },
            { label: "Result", value: "Near-Semifinals" },
          ]}
          learned={{
            label: "What We Learned",
            text:
              "The near-semifinals run exposed exactly where the robot needed to be stronger. The bike chain flipper system derailed under competition stress, and the external electrical box created bulk and access issues at the worst moments. Every failure became a direct design target for the following season.",
          }}
          primaryImage={IMG_BRAZIL}
          gallery={BRAZIL_GALLERY}
          variant="brazil"
          accent="#FF3B30"
        />

        <SectionDivider text="Iteration 02 / Full Robot Redesign" />

        <ProjectSection
          id="robocup-korea"
          index="02"
          eyebrow="// BSM Robotics · Team Lead + Mechanical Lead"
          title="RoboCup South Korea"
          timeframe="2025 — 2026"
          location="South Korea · International"
          role="Team Lead + Mechanical Lead — BSM Robotics"
          description="Brazil taught us everything we needed to know. This season I stepped into the full Team Lead role in addition to Mechanical Lead — responsible for coordinating workflows across the entire team, identifying bottlenecks, and making sure every discipline is moving forward. With a competition roster of 12 and a school-year team roughly double that, communication and task management became just as important as the engineering itself. Nearly every system on the robot has been redesigned from the ground up."
          highlights={[
            "Flippers — replaced the bike chain system with a timing belt design featuring a built-in tensioner, eliminating the derailment issues that cost us in Brazil.",
            "Track System — fully redesigned using PETG carbon fiber filament with integrated ground-contact plastic cleats for better grip and durability.",
            "Chassis — slightly shorter overall length, improving the robot's ability to navigate tight corridors and doorways for a direct scoring advantage.",
            "Electrical — upgraded batteries for extended runtime; moved the entire electrical box inside the robot frame to reduce bulk.",
            "Controls — migrated from a keyboard scheme to an Xbox controller, significantly improving operator precision and responsiveness.",
            "Cameras — expanded camera capacity with an upgraded system that now supports thermal imaging alongside standard feeds.",
            "Software — entire codebase rewritten from scratch alongside the hardware overhaul.",
          ]}
          specs={[
            { label: "Stage", value: "International" },
            { label: "Team Size", value: "12 / ~18" },
            { label: "Focus", value: "Full Redesign" },
            {
              label: "Status",
              value: "Finished",
              sub: "Highest score of any BSM team in our competition history.",
            },
          ]}
          primaryImage={IMG_KOREA}
          gallery={KOREA_GALLERY}
          variant="korea"
          accent="#00F0FF"
        />

        <SectionDivider text="Personal Project / Hardware Build" />

        <ProjectSection
          id="longboard"
          index="03"
          eyebrow="// Personal Project"
          title="Electric Longboard"
          subtitle="Custom hardware build"
          timeframe="Personal Project"
          location="Garage Build"
          role="Designer · Fabricator · Rider"
          description="A from-scratch electric longboard — the project that taught me how much I love hardware outside of competition. I selected the motor and ESC, sized and built the battery pack, designed the enclosure, and tuned the ride dynamics by actually shredding the result."
          highlights={[
            "Developed precision soldering skills — clean joints across the motor controller, BMS, and signal wiring throughout the build.",
            "Designed and fabricated a low-profile enclosure for the electronics.",
            "Tuned acceleration / braking curves through real-world ride testing.",
            "End-to-end ownership: design → fab → debug → daily driver.",
          ]}
          specs={[
            { label: "Drive", value: "Belt-Driven BLDC" },
            { label: "Pack", value: "10S3P Li-ion" },
            { label: "Top Speed", value: "~28 mph" },
            { label: "Status", value: "Daily Rider" },
          ]}
          primaryImage={IMG_LONGBOARD}
          gallery={LONGBOARD_GALLERY}
          variant="longboard"
          accent="#FF3B30"
        />

        <Contact />
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
